import { useContext } from "react"
import { WalletConnectContext } from "../../contexts/WalletConnectContext";
import { walletConnectWallet } from "./walletconnect/walletConnectClient";

export const useWalletInterface = () => {
  const walletConnectCtx = useContext(WalletConnectContext);

  if (walletConnectCtx.accountId) {
    return {
      accountId: walletConnectCtx.accountId,
      walletInterface: walletConnectWallet
    }
  } else {
    return {
      accountId: null,
      walletInterface: null
    };
  }
}